/* eslint-disable max-len */
export const ShoppingMalls = "/centra-handlowe";
export const ShoppingMallDetails = { url: "/centrum-handlowe/%7Bname%7D", type: undefined as { name: string | number; } };
export const AllShoppingMalls = "/lista-galerii-handlowych";
export const ShoppingMallFilters = { url: "/centra-handlowe/%7Bname%7D", type: undefined as { name: string | number; } };
export const ShoppingMall = { url: "/api/shopping-mall/%7Baction%7D", type: undefined as { action: string | number; } };
